export const addLanguage = (payload) => ({
    type: 'ADD_LANGUAGE',
    payload,
})

/* USER */
export const addUser = (user) => ({
    type: 'ADD_USER',
    user,
})

export const logoutUser = () => ({
    type: 'LOGOUT_USER',
})

